import {
    IonButton,
    IonButtons,
    IonContent,
    IonHeader, IonItem,
    IonLabel,
    IonPage,
    IonText,
    IonTitle,
    IonToolbar, isPlatform
} from '@ionic/react';
import ExploreContainer from '../components/ExploreContainer';
import './Tab1.css';
import React, {useState} from "react";
import {iOSVersion, WebKitVersion} from "../App";

const isIOS = (isPlatform('ios') || isPlatform('iphone') || isPlatform('ipad'));

const Tab1: React.FC = () => {
    const analyzerCanvas: any = React.useRef(null);
    let [running, setRunning] = useState(false);
    let [audioStream, setAudioStream] = useState<MediaStream | null>(null);

    const getMicrophone = async () => {
        const audioCtx = new AudioContext();
        const analyzer = audioCtx.createAnalyser();
        analyzer.smoothingTimeConstant = 0.8;
        analyzer.fftSize = 4096;
        if(navigator.mediaDevices.getUserMedia !== null)
        {
            const options = {
                video: false,
                audio: true,
            };
            try {
                const stream = await navigator.mediaDevices.getUserMedia(options);
                setAudioStream(stream);
                const audioSrc = audioCtx.createMediaStreamSource(stream);
                audioSrc.connect(analyzer);
                const freqData = new Uint8Array(analyzer.frequencyBinCount);

                const canvas = analyzerCanvas.current;
                const ctx = canvas.getContext('2d');
                const draw = (dataParm: any) => {
                    dataParm = [...dataParm];
                    ctx.fillStyle = 'white';  //white background
                    ctx.lineWidth = 2; //width of candle/bar
                    ctx.strokeStyle = '#d5d4d5'; //color of candle/bar
                    const space = canvas.width / dataParm.length;
                    ctx.clearRect(0,0, canvas.width, canvas.height);
                    dataParm.forEach((value: number, i: number) => {
                        ctx.beginPath();
                        ctx.moveTo(space * i, canvas.height); //x,y
                        ctx.lineTo(space * i, canvas.height - value); //x,y
                        ctx.stroke();
                    });
                };

                const loopingFunction = () => {
                    requestAnimationFrame(loopingFunction);
                    analyzer.getByteFrequencyData(freqData);
                    draw(freqData);
                };
                setRunning(true);
                /* "requestAnimationFrame" requests the browser to execute the code during the next repaint cycle. This allows the system to optimize resources and frame-rate to reduce unnecessary reflow/repaint calls. */
                requestAnimationFrame(loopingFunction);
            }
            catch(err) {
                // error handling
                setRunning(false);
            }
        }
    }

    const stopMicrophone = () => {
        if(audioStream)
        {
            audioStream.getAudioTracks().forEach(track => track.stop());
            setAudioStream(null);
        }
        setRunning(false);
    }

    const toggleMicrophone = () => {
        if(running)
        {
            stopMicrophone()
        }
        else
        {
            getMicrophone()
        }
    }

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Tab 1</IonTitle>
                    <IonButtons slot="end">
                        <IonButton fill={running ? "outline" : "solid"} onClick={() => toggleMicrophone()}>{running ? "Stop" : "Start"}</IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent fullscreen>
                <IonHeader collapse="condense">
                    <IonToolbar>
                        <IonTitle>Tab 1</IonTitle>
                    </IonToolbar>
                </IonHeader>
                {isIOS ? <IonItem><IonText>Browser Info</IonText></IonItem> : <IonItem></IonItem> }
                {isIOS ? <IonItem><IonText>WebKit Version: {WebKitVersion()}</IonText></IonItem> : <IonItem></IonItem>}
                {isIOS ? <IonItem><IonText>iOS Version: {iOSVersion()}</IonText></IonItem> : <IonItem></IonItem>}
                <canvas width='640px' height='200px' ref={analyzerCanvas} className="spectrum"></canvas>
            </IonContent>
        </IonPage>
    );
};

export default Tab1;
